/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Video_CompleteInputs */

const en_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video export complete!`)
};

const fr_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation vidéo terminée !`)
};

const de_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoexport abgeschlossen!`)
};

const it_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione video completata!`)
};

const ru_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео завершен!`)
};

const es_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Exportación de vídeo completada!`)
};

const zh_cn2_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频导出完成！`)
};

const ja_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポートが完了しました。`)
};

const hi_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो एक्सपोर्ट पूरा हुआ!`)
};

const pt_pt2_audio_description_export_status_video_complete = /** @type {(inputs: Audio_Description_Export_Status_Video_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de vídeo concluída!`)
};

/**
* | output |
* | --- |
* | "Video export complete!" |
*
* @param {Audio_Description_Export_Status_Video_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_complete = /** @type {((inputs?: Audio_Description_Export_Status_Video_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_video_complete(inputs)
	if (locale === "de") return de_audio_description_export_status_video_complete(inputs)
	if (locale === "it") return it_audio_description_export_status_video_complete(inputs)
	if (locale === "ru") return ru_audio_description_export_status_video_complete(inputs)
	if (locale === "es") return es_audio_description_export_status_video_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_video_complete(inputs)
	if (locale === "ja") return ja_audio_description_export_status_video_complete(inputs)
	if (locale === "hi") return hi_audio_description_export_status_video_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_video_complete(inputs)
	return en_audio_description_export_status_video_complete(inputs)
});